import { render, staticRenderFns } from "./luck.vue?vue&type=template&id=56cb3ab0&scoped=true&"
import script from "./luck.vue?vue&type=script&lang=js&"
export * from "./luck.vue?vue&type=script&lang=js&"
import style0 from "./luck.vue?vue&type=style&index=0&id=56cb3ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb3ab0",
  null
  
)

export default component.exports